import React, { useRef } from 'react'
import { FiUpload } from 'react-icons/fi'

export default function BranchImageUploader({ files = [], existingUrls = [], onAdd, onRemove, onRemoveExisting, multiple = true, maxFiles = 10 }) {
  const inputRef = useRef(null)

  const handleClick = () => {
    inputRef.current?.click()
  }

  const handleChange = (e) => {
    if (onAdd) onAdd([...e.target.files])
    e.target.value = ''
  }

  const total = files.length + (existingUrls?.length || 0)

  return (
    <div>
      <div className='branch-dropzone' onClick={handleClick}>
        <div className='branch-dropzone-icon'><FiUpload /></div>
        <div className='branch-dropzone-text'>{multiple ? 'Click to upload images' : 'Click to upload image'}</div>
        {multiple && <div className='branch-dropzone-hint'>Max {maxFiles} files (png, jpg, webp)</div>}
        <input
          ref={inputRef}
          type='file'
          hidden
          multiple={multiple}
          accept='image/*'
          onChange={handleChange}
        />
      </div>

      {total > 0 && (
        <div className='branch-preview-grid'>
          {existingUrls?.map((url, idx) => (
            <div key={`e-${idx}`} className='branch-preview-item'>
              <img src={url} alt='' />
              <button
                className='branch-preview-remove'
                onClick={() => onRemoveExisting?.(url)}
              >
                ✕
              </button>
            </div>
          ))}
          {files.map((file, idx) => (
            <div key={`n-${idx}`} className='branch-preview-item'>
              <img src={URL.createObjectURL(file)} alt='' />
              <button
                className='branch-preview-remove'
                onClick={() => onRemove?.(idx)}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
